import * as React from 'react';
import type { SVGProps } from 'react';

const SvgEditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m7.656 4.156 2.188 2.188m-8.313 3.5v2.625h2.625l8.313-8.313-2.625-2.625L1.53 9.844Z"
    />
  </svg>
);
export default SvgEditIcon;
